import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  ButtonClassesEnum,
  IButtonModel,
  IconClassesEnum,
  IClassesAttributes,
} from '@types-custom/models/ui/button-model';
import { GeoApiService } from '@shared/services/geo-api-service/geo-api.service';
import { GeoAPITypeEnum } from '@shared/models/geo-api-type.model';
import { Icon } from '@types-custom/models/ui/icon-model';
import { IPropsFilterModel, TypeFilterEnum, getLinesFilter, getStopsFilter } from '@shared/models/bus-zone.model';
import { cloneDeep } from 'lodash';
import { BusService } from '@shared/services/layer-service/bus-service/bus.service';
import { MapboxDataService } from '@sdk/services/map-box-data/mapbox-data.service';
import { MapLayers } from '@shared/utils/mappers/layers-map.model';

@Component({
  selector: 'cdm-manizales-map-filter-bus-zone',
  templateUrl: './map-filter-bus-zone.component.html',
  styleUrls: ['./map-filter-bus-zone.component.scss'],
})
export class MapFilterBusZoneComponent  implements OnInit {

  typeFilterEnum = TypeFilterEnum;

  filterLinesOptions: IPropsFilterModel[];
  filterStopsOptions: IPropsFilterModel[];

  filters: {[key:string]: any} = {
    typeId: { [TypeFilterEnum.Line]: true, [TypeFilterEnum.Stop]: false},
    lineId: '',
    stopId: '',
  };

  Icon=Icon;
  buttonTag = 'APLICAR';
  buttonAttributes: IButtonModel = {};
  restorebuttonAttributes: IButtonModel = {};
  applybuttonAttributes : IButtonModel = {};
  dropdownAttributes: IClassesAttributes = {};
  incidentsList: any = [];
  incidentsTypes: [] = [];
  formBuilder = new FormBuilder();

  semaforosChecked = false;
  currentDate = new Date();
  minStartDate = new Date();
  createButtonProps: IButtonModel = {
    label: 'APLICAR',
    classAttributes: {
      buttonClass: ButtonClassesEnum.primary_1_button,
      spanClass: IconClassesEnum.text_complementary_2,
    },
  };

  constructor(
    private busService: BusService,
    private geoApiService: GeoApiService,
    private mapboxDataService: MapboxDataService
  ) {}

  ngOnInit() {
    this.minStartDate.setDate(this.currentDate.getDate() - 30);
    this.generateButtonAttributes();
    this.filterLinesOptions = getLinesFilter();
    this.filterStopsOptions = getStopsFilter();

    this.busService.getFilter().subscribe((data) => {
      if(data) {
        this.filters = data;
      }
    });
  }

  private generateButtonAttributes(): void {
    this.buttonAttributes = {
      label: this.buttonTag,
      postIcon: Icon.search_w,
      classAttributes: {
        buttonClass: ButtonClassesEnum.primary_1_button_filter,
      },
    };
    this.restorebuttonAttributes = {
      label: 'LIMPIAR',
      postIcon: undefined,
      classAttributes: {
        buttonClass: ButtonClassesEnum.filter_button,
        spanClass: 'text-weight-600 text-size-16 h-150 p-40-px mt-18'
      },
    };
    this.applybuttonAttributes = {
      label: 'BUSCAR',
      postIcon: undefined,
      classAttributes: {
        buttonClass: ButtonClassesEnum.primary_1_button_filter,
      },
    };
  }

  initForm(requiredFilters: string[]): void {
    const formControls: { [key: string]: any } = {
      dateInit: [
        this.currentDate.toLocaleDateString('fr-CA'),
        [Validators.required],
      ],
      timeInit: ['00:00', [Validators.required]],
      dateEnd: [
        this.currentDate.toLocaleDateString('fr-CA'),
        [Validators.required],
      ],
      timeEnd: ['23:59', [Validators.required]],
    };

    requiredFilters.forEach((filter: string) => {
      formControls[filter] = [''];
    });
  }

  reloadData(response: any) {
    if(this.filters.typeId[TypeFilterEnum.Stop]) this.busService.stopsFilterNotifier$.next(response);
    if(this.filters.typeId[TypeFilterEnum.Line]) this.busService.routesFilterNotifier$.next(response);
    this.busService.setFilter(cloneDeep(this.filters));
    // validar si esta es la mejor opción
    document.querySelector<HTMLElement>('#Filtro').click();
    // para resaltar que se aplicó el filtro
    setTimeout(() => {
      document.querySelector<HTMLElement>('#Filtro').parentElement.classList.add('applied-filter');
      // Remover marker seleccionado
      document.querySelector('.marker-active-situations-layer')?.classList.remove('marker-active-situations-layer');
    }, 10);
  }

  reloadRemoveData(response: any) {
    this.busService.stopsFilterNotifier$.next(response);
    this.mapboxDataService.setLayerVisibility(MapLayers.BusZone, true);
  }

  reloadRemoveRoutesData(response: any) {
    this.busService.routesFilterNotifier$.next(response);
    this.busService.setFilter(cloneDeep(this.filters));
    // validar si esta es la mejor opción
    document.querySelector<HTMLElement>('#Filtro').click();

    // Carga las paradas de nuevo
    this.geoApiService
      .getStopBusList(GeoAPITypeEnum.StopBus, true)
      .subscribe({
        next: this.reloadRemoveData.bind(this),
      });

    // para resaltar que se aplicó el filtro
    setTimeout(() => {
      document.querySelector<HTMLElement>('#Filtro').parentElement.classList.remove('applied-filter');
      // Remover marker seleccionado
      document.querySelector('.marker-active-situations-layer')?.classList.remove('marker-active-situations-layer');
    }, 10);
  }

  onSelectButtonsType(filterName:any, deactiveOption: any, optionName:any){
    this.filters[filterName][deactiveOption] = false;
    this.filters[filterName][optionName] = !this.filters[filterName][optionName];
    this.filterLinesOptions = getLinesFilter();
    this.filterStopsOptions = getStopsFilter();
    this.filters.lineId = '';
    this.filters.stopId = '';
  }

  applyFilter(){
    // Paradas
    if(this.filters.typeId[TypeFilterEnum.Stop]) {
      const stopId = this.filters['stopId'];
      this.geoApiService
        .getStopBusList(GeoAPITypeEnum.StopBus, true, stopId)
        .subscribe({
          next: this.reloadData.bind(this),
        });
        // Borra la capa de rutas
        this.mapboxDataService.setLayerVisibility(MapLayers.BusZone, true);
        this.mapboxDataService.setLayerVisibility(`${MapLayers.BusZone}-Lines`, false);
      }

      // Rutas
      if(this.filters.typeId[TypeFilterEnum.Line]) {
        const lineId = this.filters['lineId'];
        // Borra la capa de paradas
        this.mapboxDataService.setLayerVisibility(MapLayers.BusZone, false);
        this.mapboxDataService.clearLayer(`${MapLayers.BusZone}-Lines`);
        this.geoApiService
        .getRouteBusList(GeoAPITypeEnum.RouteBus, true, lineId)
        .subscribe({
          next: this.reloadData.bind(this),
        });
    }

  }

  cleanFilter() {
    this.filters = {
      typeId: { [TypeFilterEnum.Line]: true, [TypeFilterEnum.Stop]: false },
      lineId: '',
      stopId: ''
    };

    this.mapboxDataService.clearLayer(`${MapLayers.BusZone}-Lines`);
    this.mapboxDataService.clearLayer(`${MapLayers.BusZone}`);

    this.geoApiService
      .getRouteBusList(GeoAPITypeEnum.RouteBus, true)
      .subscribe({
        next: this.reloadRemoveRoutesData.bind(this),
      });
  }



}
